__turbopack_context__.v({
  "calculations": "InjectionSimulationForm-module-scss-module__uRVhXq__calculations",
  "distance": "InjectionSimulationForm-module-scss-module__uRVhXq__distance",
  "form": "InjectionSimulationForm-module-scss-module__uRVhXq__form",
  "form-wrapper": "InjectionSimulationForm-module-scss-module__uRVhXq__form-wrapper",
  "range": "InjectionSimulationForm-module-scss-module__uRVhXq__range",
  "root": "InjectionSimulationForm-module-scss-module__uRVhXq__root",
});
